import { render, staticRenderFns } from "./SatisfactionPerQuestionForExecutives.vue?vue&type=template&id=35273fff&scoped=true&"
import script from "./SatisfactionPerQuestionForExecutives.vue?vue&type=script&lang=js&"
export * from "./SatisfactionPerQuestionForExecutives.vue?vue&type=script&lang=js&"
import style0 from "./SatisfactionPerQuestionForExecutives.vue?vue&type=style&index=0&id=35273fff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35273fff",
  null
  
)

export default component.exports